// removed by extract-text-webpack-plugin
module.exports = {"title":"title__Oa_Vy","search":"search__1OI1h","offset":"offset__1GciM","content":"content__21zJN"};


//////////////////
// WEBPACK FOOTER
// ./routes/activity/style.scss
// module id = Q8Vk
// module chunks = 27